import { useState } from "react";
import { reverseDate } from "../../utils/reverseDate";
import Ypologismos from "../Prothesmies/Ypologismos";
import Nomothesia from "../Prothesmies/Nomothesia";

const ProthesmiaRow = ({ proth }) => {
  const [activeTab, setActiveTab] = useState("none");

  if (!proth?.prothesmia || !proth?.onoma) return null;

  const toggle = (tab) =>
    setActiveTab((prev) => (prev === tab ? "none" : tab));

  return (
    <div>
      <p className="prothesmies-text">{proth.onoma}</p>
      <p className="prothesmies-date">
        {reverseDate(proth.prothesmia).replaceAll("-", ".")}
      </p>
      {proth.details && (
        <>
          <ul className="nav">
            <button
              className={
                activeTab === "Ypologismos"
                  ? "piso_button piso_button_active"
                  : "piso_button"
              }
              onClick={() => toggle("Ypologismos")}
            >
              Υπολογισμός
            </button>
            <button
              className={
                activeTab === "Nomothesia"
                  ? "piso_button piso_button_active"
                  : "piso_button"
              }
              onClick={() => toggle("Nomothesia")}
            >
              Νομοθεσία
            </button>
          </ul>
          {activeTab === "Ypologismos" && (
            <Ypologismos details={proth.details} />
          )}
          {activeTab === "Nomothesia" && (
            <Nomothesia details={proth.details} />
          )}
        </>
      )}
    </div>
  );
};

export default ProthesmiaRow;
